module.exports = __webpack_public_path__ + "img/seo-content-collapsible-mazda.a4f3ca93.png";